import _ from 'lodash';

function setAction(action, state, type) {
	const nextState = _.assign({}, state);
	let nextAction;

	// ACTIONS THAT ARE TOGGLED BACK AND FORTH (like stomping)
	if (action.toggleBetween) {
		// Remove the last action from the ones that can be chosen this time.
		// This creates the "back and forth" effect
		const availableActions = _.without(action.actions, state.lastActions[action.name]);
		// Set the next action.
		nextAction = availableActions[_.random(0, availableActions.length - 1)];
		// Save the next action to the lastActions object.
		nextState.lastActions[action.name] = nextAction;

	// ALL OTHER ACTIONS
	} else {
		// Get a new random action
		nextAction = action.actions[_.random(0, action.actions.length - 1)];
		// If it's the same as last time, reset this action.
		if (nextAction === state.actions[type][action.name]) nextAction = undefined;
	}

	// Set the state with our new action
	nextState.actions[type][action.name] = nextAction;

	// Return the new state.
	return nextState;
}

function setIdleAction(action, state) {
	return setAction(action, state, 'idle');
}

function setPetAction(action, state) {
	return setAction(action, state, 'pet');
}

export {
	setAction,
	setIdleAction,
	setPetAction,
};



// WEBPACK FOOTER //
// ./src/utils/setAction.js